import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/47_card_back_shells/47_card_back_shells"
 * Contains 1 texture(s)
 */
export class CardsBacks47CardBackShellsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/47_card_back_shells/47_card_back_shells';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '47_shells.png'
    ] as const;
}
